import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatchingGiftScreenComponent } from './matching-gift.component';
import { MaterialModule } from '../../theme/theme';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatchingGiftRouter } from './matching-gift.router';
import { MatchingGiftEffects } from './state/matching-gift.effects';
import { reducers } from './state/matching-gift.selectors';
import { AppCommonModule } from '../../app/common.module';
import { ConfirmDeactivateGuard } from 'src/commons/guards';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    FlexLayoutModule,
    MatchingGiftRouter,
    AppCommonModule,
    StoreModule.forFeature('matchingGift', reducers),
  ],
  providers: [ConfirmDeactivateGuard],
  declarations: []
})
export class MatchingGiftScreenModule { }